import { KYMW6501Model } from '../kymw6501.model';
import { TimeSaleDataModel } from '../vo/time-sale-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * タイムセールマスタ一削除
 *
 * @export API通信成功時の処理
 * @class DeleteCwsTimeSaleInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteCwsTimeSaleInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6501Model;
  private successFunc: Function;
  private vo: TimeSaleDataModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteCwsTimeSaleInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
        CategoryCode: this.vo.CategoryCode,
        UpdateDate: this.vo.UpdateDate
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6501Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof DeleteCwsTimeSaleInfo
   */
  execute(model: KYMW6501Model, vo: TimeSaleDataModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteCwsTimeSaleInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteCwsTimeSaleInfo
   */
  success(data: any) {
    this.model.kymw6501Component.deleteSuccess();
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
